import { Icon, IconProps } from '~/components/Icon/Icon';

export type DosiLogoProps = IconProps;
export const DosiLogo = (props: DosiLogoProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}>
    <path
      d="M11.575 2.5L19.8551 5.16462C22.6327 6.05907 24.5 8.628 24.5 11.5578V18.2516C24.5 21.1815 22.6338 23.7504 19.8551 24.6448L11.575 27.3095V2.5ZM13.1688 6.37628L17.9505 7.77619C19.7857 8.3139 21.0668 10.03 21.0668 11.9489V17.7597C21.0668 19.6755 19.8427 21.3437 18.0209 21.9116L13.1688 23.4228V25.116L19.3683 23.1201C21.4842 22.4389 22.9061 20.4825 22.9061 18.2506V11.5589C22.9061 9.32796 21.4842 7.37057 19.3683 6.68934L13.1688 4.69347V6.37628ZM13.1688 9.70341L15.8957 10.4356C17.0422 10.7435 17.8428 11.7898 17.8428 12.9817V16.834C17.8428 18.027 17.0412 19.0743 15.8926 19.3811L13.1688 20.1092V21.7493L17.5487 20.3848C18.7003 20.026 19.4729 18.9724 19.4729 17.7618V11.951C19.4729 10.7383 18.663 9.65349 17.5041 9.31443L13.1688 8.04453V9.70445V9.70341ZM13.1688 18.4524L15.4835 17.8346C15.9341 17.7139 16.2489 17.3031 16.2489 16.834V12.9817C16.2489 12.5136 15.9341 12.1028 15.4846 11.9822L13.1688 11.3613V18.4534V18.4524Z"
      fill="currentColor"
    />
    <path d="M8.41724 24.2219L10.0113 25.781V4.0293L8.41724 5.5873V24.2219Z" fill="currentColor" />
    <path d="M7.09409 6.88135L5.5 8.44039V21.3683L7.09409 22.9273V6.88135Z" fill="currentColor" />
  </Icon>
);
